module.exports = __webpack_public_path__ + "img/chouqian-container.bc5b21aa.png";